import { Money } from '@shared/lib/money/money'
import type { MonetaryValue } from '@shared/lib/money/money'

function normalizeDecimalInput(value: string) {
  const normalized = value.replace(',', '.').replace(/[^\d.]/g, '')
  const [integerRaw = '', ...decimalParts] = normalized.split('.')
  const integer = integerRaw.replace(/^0+(?=\d)/, '') || '0'
  const decimal = decimalParts.join('').slice(0, 3)
  return decimal.length > 0 ? `${integer}.${decimal}` : integer
}

function parseDecimal(value: string) {
  const parsed = Number(normalizeDecimalInput(value))
  return Number.isFinite(parsed) ? parsed : 0
}

function clampNumber(value: number, min: number, max: number) {
  if (!Number.isFinite(value)) return min
  return Math.min(max, Math.max(min, value))
}

export function getDiscountedPrice(price: MonetaryValue, discount: string): MonetaryValue {
  const discountPercent = clampNumber(parseDecimal(discount), 0, 100)
  const multiplier = Math.max(0, 1 - discountPercent / 100)
  const value = Money.fromMonetaryValue(price).toNumber() * multiplier
  return {
    amount: new Money(value, price.currency).toAmountString(),
    currency: price.currency,
  }
}
